import React from "react";
import "./WelcomeComponent.scss";
import iconOpenApp from "../../assets/images/icon-open-app.svg";
import iconChat from "../../assets/images/icon-chat.svg";
import iconknowledge from "../../assets/images/icon-knowledge.svg";
import iconVideo from "../../assets/images/icon-video.svg";
import useTranslation from "../../hooks/useTranslation";
import { useEffect, useState } from "react";
import useLocale from "../../hooks/useLocale";
import { PlatformDetail } from "../../types/customer";
import useAuth from "../../hooks/useAuth";
import { AxiosError } from "axios";
import customerService from "../../services/customer.service";
import welcomeJourneyService from "../../services/welcomejourney.service";


interface WelcomeComponentProps {
  closeDialog: () => void;
}
const WelcomeComponent: React.FC<WelcomeComponentProps> = ({ closeDialog }) => {
  const trans = useTranslation("WelcomeComponent");
  const localeCtx = useLocale();
  const auth = useAuth();
  const [customerPlatformDetails, setCustomerPlatformDetails] = useState<PlatformDetail[]>([]);

  const [knowledgebase ,setKnowledgeBase] = useState<string>();
  const [productTour, setProductTour] = useState<string>();
  const [chatToExpert, setChatToExpert] = useState<string>(); 

  useEffect(() => {
    if (
      !localeCtx?.selectedLocale?.current.componentTranslations[
        "WelcomeComponent"
      ]
    ) {
      trans.fetchTranslations("WelcomeComponent");
    }
  }, [localeCtx?.selectedLocale]);

  useEffect(() => {
    getCustomerPlatformDetails();    
    getLinks();
  }, [auth?.tokenPayload]);

  const getLinks = async () => {
    var knowledge = await welcomeJourneyService.getKnowledgebaseLink();
    setKnowledgeBase(knowledge);
    var product = await welcomeJourneyService.getProductTourLink();
    setProductTour(product);
    var chat = await welcomeJourneyService.getExpertChatLink();
    setChatToExpert(chat);
  }

  const getCustomerPlatformDetails = async () => {
    const customerId = auth?.tokenPayload?.CustomerId;
    if (customerId !== undefined && customerId > 0) {
      try {
        const platformDetails = await customerService.getCustomerPlatformDetail(
          customerId
        );
        setCustomerPlatformDetails(platformDetails);
      } catch (err) {
        if (err instanceof AxiosError) {
          console.log(err);
          setCustomerPlatformDetails([]);
        }
      }
    }
  };


  return (
    <div className="welcomeContainer">
      <div className="row">
        <div className="col-12">
          <div className="welTitle mb-4 pb-1"> {trans.fetchLabelKeyTranslation("Welcome","Welcome")} </div>
          <div className="welcomeContainerInner d-flex align-items-center">
            <div className="welcomeImg">
              <img src={require("../../assets/images/welcome-without-bg.png")} alt="Dashboard RecordAI" className="mw-100" />
            </div>
            <div className="welcomelinks">
              <div className="d-flex flex-column justify-content-center align-items-center">
                <div className="listtxt font28"> {trans.fetchLabelKeyTranslation("LetsGetStarted","Let’s get started")} </div>
                <a href="#" onClick={(e) => {
                    e.preventDefault(); // prevent page reload
                    closeDialog();      // close the dialog
                  }} className="listicon d-flex justify-content-center flex-column">
                  <span><img src={iconOpenApp} width="55" alt="Open App" /></span>
                  <p className="mt-2"> {trans.fetchLabelKeyTranslation("OpenApp", "Open App")} </p>
                </a>
              </div>
              <div className="pl-5 mt-3">
                <div className="fs-20 mb-2"> {trans.fetchLabelKeyTranslation("NeedSomeHelp","Need some help?")} </div>
                <ul className="list-unstyled">
                  <li className="d-flex flex-direction-column mb-3">
                    <a href={knowledgebase} target="_blank" rel="noopener noreferrer" className="listicon d-flex justify-content-start" >
                      <img src={iconknowledge} width="34" className="m-r-10" alt="Knowledge Base" />
                      <span> {trans.fetchLabelKeyTranslation("VisitKnowledgebase", "Visit our knowledge base")} </span>
                    </a>
                  </li>
                  <li className="d-flex flex-direction-column mb-3">
                    <a href={productTour} target="_blank" rel="noopener noreferrer" className="listicon d-flex justify-content-start" >
                      <img src={iconVideo} width="34" className="m-r-10" alt="Product Tour" />
                      <span> {trans.fetchLabelKeyTranslation("WatchProductTour", "Watch our product tour")} </span>
                    </a>
                  </li>
                  {(customerPlatformDetails.some((x) => x.platform === "MsTeams")) &&
                  (<li className="d-flex flex-direction-column">
                    <a href={chatToExpert} target="_blank" rel="noopener noreferrer" className="listicon d-flex justify-content-start" >
                      <img src={iconChat} width="34" className="m-r-10" alt="Chat" />
                      <span> {trans.fetchLabelKeyTranslation("ChatToExpert", "Chat to an expert")} </span>
                    </a>
                  </li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeComponent;
